
export interface IReportsFilterModel {
    id: number;
    field: string;
    categoryId: number;
    category: string;
    selectedId?: number;
    notRemovable?: boolean;
    nameId: string;
    value: string;
    dataType: typeReportsColumnDataType;
    dateRangeTo?: Date;
    dateRangeFrom?: Date;
    rangeCode?: string;
    fieldNameDB?: string;
    fieldDataType?: string;
    isCustom?: boolean;
    previewValue: string;
    multiSelect?: boolean;
    values?: string[];
    selectedIds?: number[];
    nameIds?: string[];
    isCommaSeperated?: boolean;
    isDateWithTime?: boolean;
}

//Reports Column Data Types
export const ReportsColumnDataType = {
    number: 'number',
    currencySymbol: 'currencySymbol',
    currencySymbolIgnoreTotal: 'currencySymbolIgnoreTotal',
    percentageSymbol: 'percentageSymbol',
    number2dp: 'number2dp',
    boolean: 'boolean',
    string: 'string',
    date: 'date',
    datetime: 'datetime',
    secsdhms: 'secsdhms',
    timespan: 'timespan',
    undefined: 'undefined',
    null: 'null',
    currency: 'currency',
    popuplink: 'popuplink',
} as const;
export type typeReportsColumnDataType = keyof typeof ReportsColumnDataType;

export interface IDateFilterModel {
    label: string;
    code: string;
}
